import axios from "axios";
//import config from "../config/config.json"

export const getSearch = async (request,tokenClient,searchType) => {

// console.log("request",request);

  // request = {
  //   "travelers":[{"age":30}],
  //   "business":{"token":"9fc27b0e604201550ed64ef16f9ef1a8bc8151d6"},
  //   "legs":[
  //     {
  //       "origin":{"type":"city","code":"ES:barcelona"},
  //       "destination":{"type":"city","code":"ES:madrid"},
  //       "departure":"2021-09-10T06:00",
  //       "directOnly":false
  //       }
  //   ]
  // } 

  let config = require(`../config/${tokenClient}/config.json`);

  let apiToken = searchType === "point_to_point" ? config.credential.api.token : config.credential.api.tokenPasses

  const headers = {
    'Content-Type': "application/json",
    'token': apiToken
  };

  const url = config.credential.api.url+"offer/"+searchType;

  const response = await axios.post(url,JSON.stringify(request),{headers:headers})

    .then(res => {
      return res;
    })
    .catch((err) => {
      return false;
    }); 

  return response;
}